import styled from "styled-components";

import { BaseCell } from "@similarweb/pro-logic-components";
import { IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

const GAP_X = 4;
const NEW_BADGE_WIDTH = 34;

export const StyledSidebarButton = styled(IconButton)`
    display: flex;
`;

export const StyledContent = styled(Flex)<{ $withBadges: boolean }>`
    align-items: center;
    column-gap: ${GAP_X}px;
    min-width: 0;
    width: ${({ $withBadges }) => ($withBadges ? `calc(100% - ${NEW_BADGE_WIDTH}px - ${GAP_X}px)` : "100%")};
`;

export const StyledBaseCell = styled(BaseCell)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    column-gap: ${GAP_X}px;
    overflow: hidden;

    ${StyledSidebarButton} {
        display: none;
    }

    .ant-table-row:hover & {
        ${StyledSidebarButton}, .link-out-container {
            display: flex;
        }
    }
`;
